import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: "GasIcon",
  functional: true,
  render: function render(h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 463 463",
            fill: "currentColor",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          },
          class: "feather"
        },
        ctx.data
      ]),
      [
        h("path", {
          attrs: {
            d:
              "M191.5,103c12.958,0,23.5-10.542,23.5-23.5c0-10.336-6.71-19.128-16-22.266V55.5c0-4.142-3.358-7.5-7.5-7.5\n" +
              "\t\ts-7.5,3.358-7.5,7.5v1.734c-9.29,3.138-16,11.93-16,22.266C168,92.458,178.542,103,191.5,103z M191.5,71c4.687,0,8.5,3.813,8.5,8.5\n" +
              "\t\ts-3.813,8.5-8.5,8.5s-8.5-3.813-8.5-8.5S186.813,71,191.5,71z"
          }
        }),
        h("path", {
          attrs: {
            d:
              "M111.5,103c12.958,0,23.5-10.542,23.5-23.5c0-10.336-6.71-19.128-16-22.266V55.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v1.734c-9.29,3.138-16,11.93-16,22.266C88,92.458,98.542,103,111.5,103z M111.5,71c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5s-8.5-3.813-8.5-8.5S106.813,71,111.5,71z"
          }
        }),
        h("path", {
          attrs: {
            d:
              "M351.5,103c12.958,0,23.5-10.542,23.5-23.5c0-10.336-6.71-19.128-16-22.266V55.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v1.734c-9.29,3.138-16,11.93-16,22.266C328,92.458,338.542,103,351.5,103z M351.5,71c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5s-8.5-3.813-8.5-8.5S346.813,71,351.5,71z"
          }
        }),
        h("path", {
          attrs: {
            d:
              "M271.5,103c12.958,0,23.5-10.542,23.5-23.5c0-10.336-6.71-19.128-16-22.266V55.5c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v1.734c-9.29,3.138-16,11.93-16,22.266C248,92.458,258.542,103,271.5,103z M271.5,71c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5s-8.5-3.813-8.5-8.5S266.813,71,271.5,71z"
          }
        }),
        h("path", {
          attrs: {
            d:
              "M351.5,184h-240c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h240c4.142,0,7.5-3.358,7.5-7.5S355.642,184,351.5,184z"
          }
        }),
        h("path", {
          attrs: {
            d:
              "M375.5,152h-288c-8.547,0-15.5,6.953-15.5,15.5v224c0,8.547,6.953,15.5,15.5,15.5h288c8.547,0,15.5-6.953,15.5-15.5v-224C391,158.953,384.047,152,375.5,152z M376,391.5c0,0.276-0.224,0.5-0.5,0.5h-288c-0.276,0-0.5-0.224-0.5-0.5v-224c0-0.276,0.224-0.5,0.5-0.5h288c0.276,0,0.5,0.224,0.5,0.5V391.5z"
          }
        }),
        h("path", {
          attrs: {
            d:
              "M351.5,216h-240c-4.142,0-7.5,3.358-7.5,7.5v144c0,4.142,3.358,7.5,7.5,7.5h240c4.142,0,7.5-3.358,7.5-7.5v-144C359,219.358,355.642,216,351.5,216z M344,360H119V231h225V360z"
          }
        }),
        h("path", {
          attrs: {
            d:
              "M407.5,24H391v-8.5C391,6.953,384.047,0,375.5,0h-112C254.953,0,248,6.953,248,15.5V24h-33v-8.5C215,6.953,208.047,0,199.5,0h-112C78.953,0,72,6.953,72,15.5V24H55.5C46.953,24,40,30.953,40,39.5v408c0,8.547,6.953,15.5,15.5,15.5h16c8.547,0,15.5-6.953,15.5-15.5V439h289v8.5c0,8.547,6.953,15.5,15.5,15.5h16c8.547,0,15.5-6.953,15.5-15.5v-408C423,30.953,416.047,24,407.5,24z M263,15.5c0-0.276,0.224-0.5,0.5-0.5h112c0.276,0,0.5,0.224,0.5,0.5V24H263V15.5z M87,15.5c0-0.276,0.224-0.5,0.5-0.5h112c0.276,0,0.5,0.224,0.5,0.5V24H87V15.5z M55.5,39h352c0.276,0,0.5,0.224,0.5,0.5V120H55V39.5C55,39.224,55.224,39,55.5,39z M407.5,448h-16c-0.276,0-0.5-0.224-0.5-0.5v-16c0-4.142-3.358-7.5-7.5-7.5h-304c-4.142,0-7.5,3.358-7.5,7.5v16c0,0.276-0.224,0.5-0.5,0.5h-16c-0.276,0-0.5-0.224-0.5-0.5V135h353v312.5C408,447.776,407.776,448,407.5,448z"
          }
        })
      ]
    );
  }
};
